import { FC, useEffect, useState } from 'react';

import { fadeAnimation, FadeAnimationContainer } from './FadeAnimation.styles';
import { FadeAnimationProps } from './FadeAnimation.type';

const FadeAnimation: FC<FadeAnimationProps> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(true);
  // eslint-disable-next-line  @typescript-eslint/restrict-template-expressions
  const animation = `${fadeAnimation} 2s ${isVisible ? 'infinite' : ''}`;
  const availableHeight: number = document.documentElement.clientHeight - 100;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(!isVisible);
    }, 500000);

    return () => clearTimeout(timer);
  }, [isVisible]);

  return (
    <FadeAnimationContainer
      css={{
        animation,
        height: availableHeight,
        visibility: isVisible ? 'visible' : 'hidden',
      }}
      data-testid={'fade-animation'}
    >
      {children}
    </FadeAnimationContainer>
  );
};

export default FadeAnimation;
